type ProductPage = "Internships" | "Workshops" | "Mock Interviews";
const productPaths: Record<ProductPage, string> = { Internships: "/internships", Workshops: "/workshops", "Mock Interviews": "/mock-interviews" };

export default function ProductPageRibbon({ page, current }: { page: ProductPage; current?: string }) {
    return <nav className="mz-product-ribbon" aria-label="Current location">
        <a href="/">MockZo</a>
        <span aria-hidden="true">/</span>
        {current ? <><a className="mz-product-ribbon__parent" href={productPaths[page]}>{page}</a><span aria-hidden="true">/</span><strong aria-current="page" title={current}>{current}</strong></> : <strong aria-current="page">{page}</strong>}
    </nav>;
}
